/**
 * BETA — fournisseur CRUD + stats.
 */
import { httpError } from "../router.js";
import { paginate, matchSearch, newId, nowIso } from "./_utils.js";

export function register(route) {
  route("GET", "/fournisseurs", (ctx) => {
    const { params, store } = ctx;
    let rows = [...store.data.fournisseurs];
    if (params.type) rows = rows.filter((f) => f.type === params.type);
    if (params.ville) rows = rows.filter((f) => f.ville === params.ville);
    if (params.wilaya) rows = rows.filter((f) => f.wilaya === params.wilaya);
    if (params.search)
      rows = rows.filter((f) =>
        matchSearch(f, params.search, ["nom", "telephone", "email", "ville", "nif", "rc"]),
      );
    return paginate(rows, params);
  });

  route("GET", "/fournisseurs/dropdown", (ctx) =>
    ctx.store.data.fournisseurs.map((f) => ({
      id: f.id,
      nom: f.nom,
      telephone: f.telephone,
      email: f.email,
    })),
  );

  route("GET", "/fournisseurs/:id", (ctx) => {
    const f = ctx.store.data.fournisseurs.find((x) => x.id === ctx.params.id);
    if (!f) httpError(404, "Fournisseur introuvable", "NOT_FOUND");
    return f;
  });

  route("GET", "/fournisseurs/:id/stats", (ctx) => {
    const fid = ctx.params.id;
    const achats = ctx.store.data.achats.filter((a) => a.fournisseur_id === fid);
    const valide = achats.filter((a) => a.statut === "VALIDE");
    const dernier = achats.length
      ? achats.reduce((a, b) => (a.date_facture > b.date_facture ? a : b))
      : null;
    return {
      total_achats: achats.length,
      montant_total: valide.reduce((s, a) => s + (a.montant_ttc || 0), 0),
      derniere_commande: dernier?.date_facture ?? null,
      statut_dernier: dernier?.statut ?? null,
    };
  });

  route("POST", "/fournisseurs", (ctx) => {
    const created = {
      id: newId("frn"),
      type: "GROSSISTE",
      note: null,
      created_at: nowIso(),
      ...(ctx.body || {}),
    };
    ctx.store.data.fournisseurs.push(created);
    ctx.commit();
    return created;
  });

  route("PATCH", "/fournisseurs/:id", (ctx) => {
    const f = ctx.store.data.fournisseurs.find((x) => x.id === ctx.params.id);
    if (!f) httpError(404, "Fournisseur introuvable", "NOT_FOUND");
    Object.assign(f, ctx.body || {});
    ctx.commit();
    return f;
  });

  route("DELETE", "/fournisseurs/:id", (ctx) => {
    const fid = ctx.params.id;
    const hasPending = ctx.store.data.achats.some(
      (a) => a.fournisseur_id === fid && a.statut !== "ANNULE",
    );
    if (hasPending) httpError(400, "Achats en cours empêchent la suppression", "HAS_PENDING");
    ctx.store.data.fournisseurs = ctx.store.data.fournisseurs.filter((x) => x.id !== fid);
    ctx.commit();
    return { success: true };
  });

  // X §11.1 (XWP-28) — a connection request: one uniform answer, nothing is linked here (the
  // supplier accepts on its portal).
  route("POST", "/fournisseurs/link-by-email", () => ({
    message:
      "Demande envoyée. Si cette adresse correspond à un fournisseur inscrit sur Pharmakon, il reçoit votre " +
      "demande de connexion ; il rejoindra votre carnet dès qu'il l'aura acceptée.",
    demande_envoyee: true,
  }));

  route("PATCH", "/fournisseurs/:id/note", (ctx) => {
    const f = ctx.store.data.fournisseurs.find((x) => x.id === ctx.params.id);
    if (!f) httpError(404, "Fournisseur introuvable", "NOT_FOUND");
    const n = Number(ctx.body?.note);
    if (Number.isNaN(n) || n < 0 || n > 5) httpError(400, "Note invalide (0-5)", "INVALID");
    f.note = n;
    ctx.commit();
    return f;
  });
}
